import { render, staticRenderFns } from "./RuleActions.vue?vue&type=template&id=98b338da&scoped=true&"
import script from "./RuleActions.vue?vue&type=script&lang=js&"
export * from "./RuleActions.vue?vue&type=script&lang=js&"
import style0 from "./RuleActions.vue?vue&type=style&index=0&id=98b338da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b338da",
  null
  
)

export default component.exports
import QItem from 'quasar/src/components/item/QItem.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QTime from 'quasar/src/components/time/QTime.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QItem,QInput,QToggle,QBtn,QSelect,QDialog,QDate,QTime});qInstall(component, 'directives', {ClosePopup});
